if (document.querySelector('#form-newsletter') !== null) {
    const $formNewsletter = document.querySelector('#form-newsletter');
    $formNewsletter.addEventListener('submit', (e) => {
        e.preventDefault();

        const url = `${site_url}/services/sendFormNewsletter`;
        const data = $('#form-newsletter').serialize();

        grecaptcha.ready(function() {
            grecaptcha.execute(reCaptcha_key, { action: 'form_newsletter' }).then(function(token) {

                $.ajax({
                    type: "POST",
                    data: data + '&form_token=' + token,
                    url: url
                }).done(function(data) {
                    var json = JSON.parse(data);
                    if (json.status == 'success') {
                        console.log('success');
                        $(".form-response").prepend(json.message).show();
                    } else if (json.status == 'error') {
                        $(".form-response").find('.alert').remove();
                        $(".form-response").prepend(json.message);
                    }

                }).always(function() {
                    loadData = false;
                });

            });
        });
    });
}